<template>
  <div class="nzm_scroll_imgs" v-if="data_list && data_list.length > 0" :style="getNzmWrapStyle(info)">
    <div v-for="(item, index) in data_list" :key="index" class="img_block" :style="block_style">
      <img
        class="img_content"
        v-lazy="item.img"
        @click.prevent="click_item($event,item)"
        :style="block_style"
      />

      <div class="icon" v-if="item.icon">
        <CoverIcon :info="item.icon" />
      </div>

      <div class="m5_info">
        <div :style="textMainColorStyle" class="title">{{item.title}}</div>
        <div :style="textSubColorStyle" class="sub_title">{{item.sub_title}}</div>
      </div>
    </div>
  </div>
</template>
<script>
import { getJSON, getJSONP } from "../../../api/myaxios";
import { openLink } from "../../../tools/mgtv/link";
import click_handler from "../../../tools/mgtv/click";
import handle_action from "../../../tools/mgtv/action";
import CoverIcon from "../CoverIcon";
import {getNzmWrapStyle} from '../../../tools/mgtv/nzmWrapStyle'

const configs = {
  m01: {
    style: {
      width: "2.1rem",
      height: "1.2rem"
    }
  },
  m02: {
    style: {
      width: "2.8rem",
      height: "1.57rem"
    }
  }
};

export default {
  name: "Imgs",
  components: { CoverIcon },
  props: {
    info: {
      type: Object
    },
    data_list: {
      type: Array
    },
    custom_color:{
      type:Boolean,
      default:true
    }

  },
  data: function() {
    return {};
  },
  methods: {
    getNzmWrapStyle,
    click_item(e, item) {
      click_handler(
        `${this.info.act_name_chn}-点击-${item.id}`,
        () => {
          handle_action(item);
        },
        {
          need_act: item.action_info.need_act,
          need_login: item.action_info.need_login,
          need_new_user: item.action_info.need_new_user
        }
      );
    }
  },
  mounted() {},

  computed: {
    show_type: function() {
      return this.info.config.show_type || "m01";
    },
    config: function() {
      return configs[this.show_type];
    },
    block_style: function() {
      return this.config.style;
    },
    textMainColorStyle: function() {
      if(!this.custom_color){
        return {}
      }
      return window.$bus.textMainColorStyle;
    },
    textSubColorStyle: function() {
      if(!this.custom_color){
        return {}
      }
      return window.$bus.textSubColorStyle;
    }
  }
};
</script>


<style lang="stylus" scoped>
  @import "../../../share/mixins.styl"
  .nzm_scroll_imgs
    position relative
    width 7.5rem
    overflow-y hidden
    overflow-x scroll
    -webkit-overflow-scrolling touch
    display flex
    padding 0 0.1rem
    &::-webkit-scrollbar
      display:none;
      width: 0 !important
      background: transparent;
    .m5_info
      width 100%

    .title
      width 100%
      font-size .28rem
      color #333333
      ellipsis()
      margin-top .2rem
      @media screen and (min-width: 700px)
        font-size 14PX
    .sub_title
      width 100%
      font-size .24rem
      margin-top .12rem
      color #969696
      ellipsis()
      @media screen and (min-width: 700px)
        font-size 12PX

    .img_block
      position relative
      flex-shrink  0
      margin 0 .05rem
      height  auto !important
      .icon
        position absolute
        top .1rem
        right .1rem
      .img_content
        border-radius .05rem
        width 100%
        height 100%




</style>
